import { ThunkDispatch } from "redux-thunk";

import createValueModule from "@/redux/create-value-module";
import { IState, TExtraThunkArgs, TValueAction } from "@/redux/store.types";

import { getErrors } from "./errors.selectors";
import { $ErrorsModuleName, TError, TErrorsState } from "./errors.types";

const { constants: _constants, actions } = createValueModule<TErrorsState>(
    $ErrorsModuleName,
    {
        alerts: []
    }
);

export const setError =
    (error: TError) =>
    (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: any
    ) => {
        const alerts = getErrors(getState()) || [];
        let newAlertArray = [...alerts];
        const index = alerts.findIndex(
            (alert: any) =>
                alert.url === error.url && alert.method === error.method
        );
        if (index !== -1) {
            newAlertArray = [
                ...alerts.slice(0, index),
                ...alerts.slice(index + 1)
            ];
        }
        newAlertArray.push(error);
        return dispatch(actions.set({ alerts: newAlertArray }));
    };

export const deleteError =
    (error: TError) =>
    (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: any
    ) => {
        const alerts = getErrors(getState()) || [];
        let newAlertArray = [...alerts];
        const index = alerts.findIndex(
            (alert: any) =>
                alert.url === error.url && alert.method === error.method
        );
        if (index !== -1) {
            newAlertArray = [
                ...alerts.slice(0, index),
                ...alerts.slice(index + 1)
            ];
        }
        return dispatch(actions.set({ alerts: newAlertArray }));
    };
